import React, { FC, useState } from "react";
import styled from "styled-components";

interface Props {
  tags: string[];
  onChange?: any;
}

const TagsFilter: FC<Props> = ({ tags, onChange }) => {
  const [checked, setChecked] = useState<Array<string>>([]);

  const selectFilter = (value) => {
    let result;
    if (!checked.includes(value)) {
      const newArr = [...checked, ...value.split()];
      result = newArr;
    } else {
      let deleteItemArr = checked.filter((item) => item !== value);
      result = deleteItemArr;
    }

    setChecked(result);
    onChange(result);
  };

  return (
    <Wrraper className="kabel">
      {tags.map((item) => (
        <Block key={item} active={checked.includes(item)}>
          <Filter
            onClick={() => {
              selectFilter(item);
            }}
            active={checked.includes(item)}
          >
            {item}
          </Filter>
          <span className="icon" onClick={() => selectFilter(item)} />
        </Block>
      ))}
    </Wrraper>
  );
};

const Wrraper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

const Block = styled.div<FilterWithProps>`
  display: flex;
  position: relative;
  .icon {
    height: 36px;
    width: 30px;
    display: ${({ active }) => (active ? "block" : "none")};
    background: url("/static/icons/close.svg") no-repeat center;
    background-size: 10px 10px;
    right: 20px;
    position: absolute;
    cursor: pointer;
    transition: 0.2s;
  }
`;

interface FilterWithProps {
  active?: boolean;
}

const Filter = styled.div<FilterWithProps>`
  background-color: ${({ active }) => (active ? "#78B833" : "#fff")};
  color: ${({ active }) => (active ? "#fff" : "#000")};
  padding: ${({ active }) => (active ? "0 30px 0 20px" : "0 20px 0 20px")};
  transition: 0.2s;
  box-shadow: ${({ active }) =>
    active
      ? "0px 6px 12px rgba(164, 202, 57, 0.632869)"
      : "0px 6px 12px rgba(164, 202, 57, 0)"};
  border-radius: 15px;
  cursor: pointer;
  height: 34px;
  display: flex;
  align-items: center;
  margin: 0 16px 16px 0;
`;

export default TagsFilter;
